import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewGameFreespin = (params) => {
    return axios.get(`${backendHost}/api/admin/fs-game/view`, {params});
};

export {
    getViewGameFreespin
}